import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import CSelect from '@/components/CForm/CSelect'
import CRadio from '@/components/CForm/CRadio'
import CInput from '@/components/CForm/CInput'
import { setReload } from "@/redux/common/action";
import _ from 'lodash'
import { tableData1} from './data'
import './index.scss'

import { adminscorequeryHanndler,expertmuseumscoredetail } from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
import {Button, message, Modal} from 'antd'
@CBaseComponent
class GoodsManageList extends Component{
    constructor(props) {
        super(props);
        this.getListData = this.getListData.bind(this);
        this.modalOk = this.modalOk.bind(this);
        this.modalCancel = this.modalCancel.bind(this);
        this.searchHandler = this.searchHandler.bind(this)
        this.onChange = this.onChange.bind(this)
        this.onChangeintegrity = this.onChangeintegrity.bind(this)
        this.onChangemuseumname = this.onChangemuseumname.bind(this)
        this.onChangeresult = this.onChangeresult.bind(this)
        this.onChangevalue1 = this.onChangevalue1.bind(this)
        this.onChangevalue2 = this.onChangevalue2.bind(this)
        this.onChangeindicatorid = this.onChangeindicatorid.bind(this)
        this.onChangescoretype = this.onChangescoretype.bind(this)
        this.onChangelevel = this.onChangelevel.bind(this)
        this.computedData = this.computedData.bind(this)
        this.computedData1 = this.computedData1.bind(this)
        this.computedData2 = this.computedData2.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        // reload时重新加载数据
        // this.getListData();
    }


    state = {
        columns1: tableData1.tHead,
        dataSource: [],
        dataSource1: tableData1.tBody,
        dataSource1all: tableData1.tBody,
        loading: true,
        level:0,
        modal: {
            title: '',
            visible: false,
        },
        deleteid:'',
        annual: '',
        levelid: '',
        ownerlist:[],
        museumname:'',
        levellist:[
            {name:'全部',value:1}
        ],
        options:[],
        detaildata:[],
        wzxlist:[
            {name:'不限',value:1}
        ],
        pglist:[
            {name:'不限',value:1}
        ],
        citylist:[],
        provinceid:'',
        integritylist:[],
        integrity:'',
        resultlist:[],
        result:'',
        indicatorlist:[],
        minscore:'',
        maxscore:'',
        typelist:[],
        scoretype:'',
        indicatorid:''
    };

    modalCancel(){
        this.setState({
            modal: {...this.state.modal, visible: false},
            dataSource1:[],
            dataSource1All:[]
        })
    }
    searchHandler(){
        this.getListData()
    }

    onChange(data){
        this.setState({
            provinceid:data
        })
    }
    onChangevalue1(data){
        this.setState({
            minscore:data
        })
    }
    onChangevalue2(data){
        this.setState({
            maxscore:data
        })
    }

    onChangeintegrity(data){
        this.setState({
            integrity:data
        })
    }
    onChangemuseumname(data){
        this.setState({
            museumname:data
        })
    }

    onChangelevel(data){
        this.setState({
            levelid:data
        })
    }

    onChangeresult(data){
        this.setState({
            result:data
        })
    }

    onChangescoretype(data){
        this.setState({
            scoretype:data
        })
    }

    onChangeindicatorid(data){
        this.setState({
            indicatorid:data
        })
    }

    modalCancel(){
        this.setState({
            modal: {...this.state.modal, visible: false},
            deleteid:''
        })
    }

    modalOk(){
        // const params = {
        //   id: this.state.deleteid
        // }
        // expertdelete(params).then(res=>{
        //   if (res.statecode === 0) {
        //     message.success('删除成功');
        //     this.modalCancel()
        //     this.getListData()
        //   } else {
        //     message.error('删除失败');
        //   }
        // })
    }

    // 获取用户列表数据
    getListData(){
        this.setState({
            loading: true
        });
        const params = {
            annual:this.state.annual,
            levelid:this.state.levelid,
            museumname:this.state.museumname,
            provinceid:this.state.provinceid === '-1' ? '' : this.state.provinceid,
            integrity:this.state.integrity,
            result:this.state.result,
            minscore:this.state.minscore,
            maxscore:this.state.maxscore,
            scoretype:this.state.scoretype,
            indicatorid:this.state.indicatorid,
        }
        adminscorequeryHanndler(params).then(res=>{
            if (res.statecode === 0) {
                res.records[0].levellist.forEach(item=>{
                    item.value = item.id
                })
                res.records[0].provincelist.forEach((item,index)=>{
                    if (index === 0) {
                        item.value = '-1'
                        item.id = '-1'
                    } else {
                        item.value = item.id
                    }
                })
                res.records[0].integritylist.forEach(item=>{
                    item.value = item.id
                })
                res.records[0].resultlist.forEach(item=>{
                    item.value = item.id
                })
                res.records[0].indicatorlist.forEach(item=>{
                    item.value = item.id
                })
                res.records[0].typelist.forEach(item=>{
                    item.value = item.id
                })
                this.setState({
                    dataSource: res.records[0].museumlist,
                    options: res.records[0].levellist,
                    loading:false,
                    citylist:res.records[0].provincelist,
                    integritylist:res.records[0].integritylist,
                    resultlist: res.records[0].resultlist,
                    indicatorlist:res.records[0].indicatorlist,
                    typelist:res.records[0].typelist
                });
            }
        }).catch(err=>{
            console.log(err,'rttt')
        })
    }

    getAlertSelect(data){
        const params = []
        this.state.dataSource1all.forEach(item=>{
            if (data === 4) {
        params.push(item)
      } else {
        if (Number(item.rank) <= Number(data)) {
          params.push(item)
        }
      }
        })
        this.setState({
            dataSource1: params
        })
    }

    selectDtail(data){
        const params = {
            museumid:data[13]
        }
        expertmuseumscoredetail(params).then(res=>{
            if (res.statecode === 0) {
                this.setState({
                    modal: {...this.state.modal, visible: true,title:'评分详情:'+data[1]}
                });
                setTimeout(()=>{
                    this.setState({
                        dataSource1:res.records,
                        dataSource1all:res.records,
                    })
                })
            }
        })
    }

    createMarkup(str) {
        return {__html: str}
    }

    computedScore(data){
        return Math.round((Number(data.score1)+Number(data.score2)+Number(data.score3))/3)
    }

    computedData(data){
        let str= ''
        data.label1.forEach(item=>{
            str+=item+'</br>'
        })
        return <div dangerouslySetInnerHTML={this.createMarkup(str)}></div>;
    }
    computedData1(data){
        let str= ''
        data.label2.forEach(item=>{
            str+=item+'</br>'
        })
        return <div dangerouslySetInnerHTML={this.createMarkup(str)}></div>;
    }
    computedData2(data){
        let str= ''
        data.label3.forEach(item=>{
            str+=item+'</br>'
        })
        return <div dangerouslySetInnerHTML={this.createMarkup(str)}></div>;
    }


    componentWillMount(){

    }

    componentDidMount(){
        this.getListData();
    }

    render(){
        return (
            <div className='user-manage-list'>
                <div className='flex filter-wrap'>
                    <div className='filter-left' style={{width:'100%'}}>
                        <div style={{marginBottom:'10px'}}>
                            <label htmlFor="">
                                名称：</label>
                            <CInput
                                value={this.state.museumname}
                                placeholder='请输入名称'
                                style={{width:'200px'}}
                                onChange={this.onChangemuseumname}
                            />
                        </div>
                        <div style={{marginBottom:'10px'}}>
                            <label htmlFor="">
                                质量等级：</label>
                            <CRadio value={this.state.levelid}
                                    options={this.state.options}
                                    onChange={this.onChangelevel}
                            />
                        </div>
                        <div style={{marginBottom:'10px'}}>
                            <label htmlFor="">
                                博物馆所处省份：</label>
                            <CSelect
                                value={this.state.provinceid}
                                options={this.state.citylist}
                                placeholder='请选择所处省份'
                                onChange={this.onChange}
                                style={{width:'100px'}}
                            />
                        </div>
                        <div style={{marginBottom:'10px'}}>
                            <label htmlFor="">
                                评估成绩：</label>
                            <CRadio value={this.state.result}
                                    options={this.state.resultlist}
                                    onChange={this.onChangeresult}
                            />
                        </div>
                        <div style={{marginBottom:'10px'}}>
                            <label htmlFor="">
                                指标分值：</label>
                            <CSelect
                                value={this.state.indicatorid}
                                options={this.state.indicatorlist}
                                placeholder='请选择'
                                onChange={this.onChangeindicatorid}
                                style={{width:'100px',marginRight:'10px'}}
                            />
                            <CSelect
                                value={this.state.scoretype}
                                options={this.state.typelist}
                                placeholder='请选择'
                                onChange={this.onChangescoretype}
                                style={{width:'100px',marginRight:'10px'}}
                            />
                            <CInput
                                value={this.state.minscore}
                                placeholder='请输入分数'
                                style={{width:'100px'}}
                                onChange={this.onChangevalue1}
                            />
                            <span  style={{margin:'0 10px'}}>分至</span>
                            <CInput
                                value={this.state.maxscore}
                                placeholder='请输入分数'
                                style={{width:'100px',marginRight:'10px'}}
                                onChange={this.onChangevalue2}
                            />
                        </div>
                        <CButton type='primary' onClick={this.searchHandler}>查询</CButton>
                    </div>
                </div>
                {
                    this.state.dataSource.map((item,index1)=>{
                        return (<div style={{display:'flex',borderBottom:'1px solid #bebebe',marginTop:'20px'}}>
                            {
                                item.map((item2,index2)=>{
                                    if (index2 === 13 && index1 !==0){
                                        return (
                                            <CButton type='primary' onClick={()=>{this.selectDtail(item)}}>查看</CButton>
                                        )
                                    } else {
                                        return (
                                            <div style={{flex:1,textAlign:'center',marginBottom:'10px',alignItems:'center'}}>{item2}</div>
                                        )
                                    }
                                })
                            }
                        </div>)
                    })
                }
                <Modal
                    title={this.state.modal.title}
                    visible={this.state.modal.visible}
                    onCancel={this.modalCancel}
                    width={860}
                    footer={null}
                >
                    <div>
                        <div>
                            指标项显示层级：
                            <CButton type='primary' size="mini" onClick={() => this.getAlertSelect(4)} style={{marginRight:'20px'}}>
                                全部
                            </CButton>
                            <CButton type='primary' size="mini" onClick={() => this.getAlertSelect(3)} style={{marginRight:'20px'}}>
                                三级及以上
                            </CButton>
                            <CButton type='primary' size="mini" onClick={() => this.getAlertSelect(2)} style={{marginRight:'20px'}}>
                                二级及以上
                            </CButton>
                        </div>
                        <CTable ref='historyRecordDeleteUserList1' checked={false} loading={false} columns={this.state.columns1} dataSource={this.state.dataSource1}>
                            <div
                                slot='index'
                                render={(text, record, index) => (
                                    <div className='operate'>
                                        {index+1}
                                    </div>
                                )} />
                            <div
                                slot='operate2019'
                                render={(text, record, index) => (
                                    <div className='operate'>
                                        <span>{this.computedData(record)}</span>
                                    </div>
                                )} />
                            <div
                                slot='operate2020'
                                render={(text, record, index) => (
                                    <div className='operate'>
                                        <span>{this.computedData1(record)}</span>
                                    </div>
                                )} />
                            <div
                                slot='operate2021'
                                render={(text, record, index) => (
                                    <div className='operate'>
                                        <span>{this.computedData2(record)}</span>
                                    </div>
                                )} />
                            <div
                                slot='index'
                                render={(text, record, index) => (
                                    <div className='operate'>
                                        {index+1}
                                    </div>
                                )} />
                            {/*<div*/}
                            {/*    slot='pjf'*/}
                            {/*    render={(text, record, index) => (*/}
                            {/*        <div className='operate'>*/}
                            {/*            {this.computedScore(record)}*/}
                            {/*        </div>*/}
                            {/*    )} />*/}
                        </CTable>
                    </div>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        reload: state.reload,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setReload: bindActionCreators(setReload, dispatch)
    }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
